import { useCallback, useEffect } from 'react';

import { focusUniversalSearchInput } from '@/components/UniversalSearchButton';

export const UniversalSearchHotkeys = () => {
    const keydownListener = useCallback((keydownEvent: KeyboardEvent) => {
        if (keydownEvent.metaKey && keydownEvent.key === 'k') {
            keydownEvent.preventDefault();
            focusUniversalSearchInput();
        } else if (keydownEvent.ctrlKey && keydownEvent.key === 'k') {
            keydownEvent.preventDefault();
            focusUniversalSearchInput();
        } else if (keydownEvent.key === '/' && shouldFocusSearchFromSlash()) {
            keydownEvent.preventDefault();
            focusUniversalSearchInput();
        }
    }, []);

    useEffect(() => {
        window.addEventListener('keydown', keydownListener);
        return () => {
            window.removeEventListener('keydown', keydownListener);
        };
    }, [keydownListener]);

    return null;
};

const shouldFocusSearchFromSlash = () => {
    const activeElement = document.activeElement;

    if (!activeElement || activeElement === document.body || activeElement === document.documentElement) {
        return true;
    }

    if (
        activeElement instanceof HTMLInputElement ||
        activeElement instanceof HTMLTextAreaElement ||
        activeElement instanceof HTMLSelectElement
    ) {
        return false;
    }

    if (activeElement instanceof HTMLElement && activeElement.isContentEditable) {
        return false;
    }

    return false;
};
